/**
 * Geos App Workaround
 *
 * Temporary fix for duplicated "EUR €" entries shown in the Geos
 * currency selector. The app renders one entry per European country
 * but displays only the currency label, making them appear duplicated.
 *
 * This script renames the labels for better user experience without
 * modifying Geos functionality.
 *
 * Remove this file once Geos provides an official fix.
 */
(function () {
  const labels = {
    ES: "Spain (EUR €)",
    PT: "Portugal (EUR €)",
    DE: "Germany (EUR €)",
    IT: "Italy (EUR €)",
    FR: "France (EUR €)",
    NO: "Norway (EUR €)",
    SE: "Sweden (EUR €)",
    CH: "Switzerland (EUR €)",
    BE: "Belgium (EUR €)",
    NL: "Netherlands (EUR €)",
    IE: "Ireland (EUR €)"
  };

  function renameCurrencies() {
    const items = document.querySelectorAll(".select-option-item");

    if (!items.length) return false;

    items.forEach(item => {
      const code = item.dataset.code;
      const span = item.querySelector("span");

      if (span && labels[code]) {
        span.textContent = labels[code];
      }
    });

    return true;
  }

  function waitForPopup() {
    // Subukan agad kung bukas na ang popup
    if (renameCurrencies()) return;

    const observer = new MutationObserver(() => {
      if (renameCurrencies()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Safety: tumigil pagkatapos ng 10 seconds
    setTimeout(() => observer.disconnect(), 10000);
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Hintayin ang Geos popup na ma-render
    setTimeout(waitForPopup, 500);
  });
})();